import { useTranslate } from '@va/localization';
import { ConfirmationDialogProps, ConfirmationModal } from '@va/shared/util-confirmation';

const CancelPrivacyLevelChangesModal: React.FC<ConfirmationDialogProps> = ({ onClose, onConfirm }) => {
  const translate = useTranslate();

  return (
    <ConfirmationModal
      info={translate('modal.cancelPrivacyChanges.info')}
      title={translate('modal.cancelPrivacyChanges.title')}
      onClose={onClose}
      onConfirmation={onConfirm}
      isOpen={true}
      actionButtonText={translate('button.confirm')}
    />
  );
};

export default CancelPrivacyLevelChangesModal;
